import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

const useDeleteUnassignedStep = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [data, setData] = useState(null);

  const deleteUnassignedStep = async (tourPlanningId) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.delete(
        `/tours-planning/unassigned/${tourPlanningId}`
      );

      if (response.status === 200) {
        setIsSuccess(true);
        setData(response.data);
        toast.success(
          response.data?.message || 'Étape non affectée supprimée avec succès'
        );
        return response.data;
      } else {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }
    } catch (error) {
      setIsSuccess(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Erreur lors de la suppression de l'étape"
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setIsSuccess(false);
    setIsLoading(false);
    setData(null);
  };

  return {
    isLoading,
    isSuccess,
    data,
    deleteUnassignedStep,
  };
};

export default useDeleteUnassignedStep;

